import React, { Children } from 'react';
import { IconNote, IconSearch, IconListCheck, IconChevronRight } from '@tabler/icons-react';
import { YeppyChatMode } from '../components/EmptyChatSuggestions';
import { MiniGantt } from '../components/MiniGantt';
interface HomePageProps {
  onNewChat: (mode?: YeppyChatMode) => void;
  onOpenChild: (childId: string, childName?: string) => void;
  onOpenActivities: () => void;
  onOpenFamily: () => void;
}
const mockChildren = [{
  id: 'child-1',
  name: 'Sofia',
  age: 6,
  avatar: 'https://cdn.magicpatterns.com/uploads/c3jxasi4fCCZ93c9aemubP/adele-shafiee-KCvjle4_4ps-unsplash.jpg',
  infoCount: 24
}, {
  id: 'child-2',
  name: 'Marco',
  age: 4,
  avatar: 'https://cdn.magicpatterns.com/uploads/1EXQ4FkeqG6UuqJKWikck9/tatev-arsh-ZtB5Haz58os-unsplash.jpg',
  infoCount: 18
}];
const mockCaregivers = [{
  id: '1',
  name: 'Maria',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face',
  percentage: 62,
  color: '#B0EC9C'
}, {
  id: '2',
  name: 'Luca',
  avatar: 'https://cdn.magicpatterns.com/uploads/7G4z2y5zxpC8H8Kk9BNvv6/felipe-salgado-zssU4tUQ-18-unsplash.jpg',
  percentage: 38,
  color: '#AEDAFF'
}];
export function HomePage({
  onNewChat,
  onOpenChild,
  onOpenActivities,
  onOpenFamily
}: HomePageProps) {
  return <div className="flex-1 overflow-y-auto bg-yeppy-bg pb-20" data-id="element-819">
      <div className="px-4 py-4 space-y-6" data-id="element-820">
        {/* Greeting */}
        <div className="pt-1" data-id="element-821">
          <h1 className="font-rubik font-medium text-[22px] text-yeppy-text" data-id="element-822">
            Ciao Fabio 👋
          </h1>
          <p className="font-poppins text-sm text-yeppy-text/60 mt-1" data-id="element-823">
            Di cosa hai bisogno oggi?
          </p>
        </div>

        {/* Action Cards */}
        <div className="grid grid-cols-3 gap-2.5" data-id="element-824">
          <button onClick={() => onNewChat('ascolto')} className="flex flex-col items-center gap-2 py-3 px-2 rounded-2xl bg-white border border-yeppy-text/8 transition-all active:scale-[0.96]" data-id="element-825">
            <IconNote className="w-6 h-6 text-yeppy-text" stroke={1.5} data-id="element-826" />
            <span className="font-rubik text-xs text-yeppy-text text-center leading-tight font-[400]" data-id="element-827">
              Racconta
            </span>
          </button>

          <button onClick={() => onNewChat('informazioni')} className="flex flex-col items-center gap-2 py-3 px-2 rounded-2xl bg-white border border-yeppy-text/8 transition-all active:scale-[0.96]" data-id="element-828">
            <IconSearch className="w-6 h-6 text-yeppy-text" stroke={1.5} data-id="element-829" />
            <span className="font-rubik text-xs text-yeppy-text text-center leading-tight font-[400]" data-id="element-830">
              Cerca info
            </span>
          </button>

          <button onClick={() => onNewChat('attivita')} className="flex flex-col items-center gap-2 py-3 px-2 rounded-2xl bg-white border border-yeppy-text/8 transition-all active:scale-[0.96]" data-id="element-831">
            <IconListCheck className="w-6 h-6 text-yeppy-text" stroke={1.5} data-id="element-832" />
            <span className="font-rubik text-xs text-yeppy-text text-center leading-tight font-[400]" data-id="element-833">
              Organizza
            </span>
          </button>
        </div>

        {/* Attività Widget */}

        {/* Calendario — Mini Gantt */}
        <section data-id="element-834">
          <MiniGantt onViewAll={onOpenActivities} data-id="element-835" />
        </section>

        {/* Figli */}
        <section data-id="element-836">
          <div className="flex items-center justify-between mb-3" data-id="element-837">
            <h2 className="font-rubik font-semibold text-xs uppercase tracking-wider text-yeppy-text text-opacity-40" data-id="element-838">
              Figli
            </h2>
            <button onClick={onOpenFamily} className="font-poppins text-sm text-yeppy-text text-opacity-60 flex items-center gap-1" data-id="element-839">
              Vedi tutti
              <IconChevronRight className="w-4 h-4" stroke={1.5} data-id="element-840" />
            </button>
          </div>
          <div className="grid grid-cols-2 gap-3" data-id="element-841">
            {mockChildren.map(child => {
            return <button key={child.id} onClick={() => onOpenChild(child.id, child.name)} className="bg-white border border-yeppy-text border-opacity-10 rounded-2xl p-4 flex flex-col items-center text-center gap-2 transition-transform active:scale-95" data-id="element-842">
                  <img src={child.avatar} alt={child.name} className="w-14 h-14 rounded-full object-cover border-2 border-yeppy-text/5" data-id="element-843" />
                  <div data-id="element-844">
                    <h3 className="font-poppins font-medium text-sm text-yeppy-text" data-id="element-845">
                      {child.name}
                    </h3>
                    <p className="font-poppins text-[11px] text-yeppy-text/50 mt-0.5" data-id="element-846">
                      {child.age} anni
                    </p>
                    <div className="mt-2 inline-flex items-center justify-center px-2 py-0.5 bg-yeppy-bg rounded-full border border-yeppy-text/5" data-id="element-847">
                      <span className="font-poppins text-[10px] text-yeppy-text/60" data-id="element-848">
                        {child.infoCount} info
                      </span>
                    </div>
                  </div>
                </button>;
          })}
          </div>
        </section>

        {/* Nucleo Familiare */}
        <section data-id="element-849">
          <div className="flex items-center justify-between mb-3" data-id="element-850">
            <h2 className="font-rubik font-semibold text-xs uppercase tracking-wider text-yeppy-text text-opacity-40" data-id="element-851">
              Nucleo Familiare
            </h2>
            <button onClick={onOpenFamily} className="font-poppins text-sm text-yeppy-text text-opacity-60 flex items-center gap-1" data-id="element-852">
              Vedi tutti
              <IconChevronRight className="w-4 h-4" stroke={1.5} data-id="element-853" />
            </button>
          </div>
          <div className="bg-white border border-yeppy-text border-opacity-10 rounded-2xl p-4 space-y-4" data-id="element-854">
            {mockCaregivers.map(caregiver => <div key={caregiver.id} className="flex items-center gap-3" data-id="element-855">
                <img src={caregiver.avatar} alt={caregiver.name} className="w-10 h-10 rounded-full object-cover border border-yeppy-text/10 flex-shrink-0" data-id="element-856" />
                <div className="flex-1 min-w-0" data-id="element-857">
                  <div className="flex items-center justify-between mb-1.5" data-id="element-858">
                    <span className="font-poppins text-sm font-medium text-yeppy-text" data-id="element-859">
                      {caregiver.name}
                    </span>
                    <span className="font-rubik font-medium text-sm text-yeppy-text" data-id="element-860">
                      {caregiver.percentage}%
                    </span>
                  </div>
                  <div className="w-full h-2 bg-yeppy-bg rounded-full overflow-hidden" data-id="element-861">
                    <div className="h-full rounded-full transition-all duration-500" style={{
                  width: `${caregiver.percentage}%`,
                  backgroundColor: '#1D2A36'
                }} data-id="element-862" />
                  </div>
                </div>
              </div>)}
          </div>
        </section>
      </div>
    </div>;
}